import React from 'react';
import { HeartCrackIcon, DollarSignIcon, HelpCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const stats = [{
    icon: HeartCrackIcon,
    title: 'Diagnósticos sin apoyo',
    description: 'Familias enfrentan diagnósticos complejos sin recursos ni orientación'
  }, {
    icon: DollarSignIcon,
    title: 'Costos inaccesibles',
    description: 'Terapias y tratamientos biomédicos fuera del alcance económico'
  }, {
    icon: HelpCircleIcon,
    title: 'Decisiones aisladas',
    description: 'Padres toman decisiones críticas sin información integrada'
  }];
  return <section id="nosotros" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-173" data-mp="3jdzbkhnhx87l">
      <div className="max-w-6xl mx-auto" data-id="element-174" data-mp="3ehie2wuephhu">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-175" data-mp="1p215gokhgsfx">
          <div data-id="element-176" data-mp="1p454ot7ft39v">
            <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-4" data-id="element-177" data-mp="1p3vmhrsmw0eq">
              El Problema
            </h2>
            <p className="text-lg text-gray-600" data-id="element-178" data-mp="jddf4g0mmqz8">
              Familias con niños neurodiversos enfrentan barreras económicas que
              limitan el acceso a educación, orientación y evaluaciones
              profesionales
            </p>
          </div>
          <div data-id="element-179" data-mp="sbp1u6ydh4me">
            <img src="https://cdn.magicpatterns.com/uploads/eBEDv17LBRGEQhmeBueWEQ/heylloyd-image-1782595943394.png" alt="Madre preocupada con su hijo" className="w-full h-80 object-cover rounded-2xl shadow-lg" data-id="element-180" data-mp="sbywi7ud3zyf" />
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-181" data-mp="174ivcwahbla2">
          {stats.map((stat, index) => <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" data-id="element-182" data-mp="1bzy5bd5d8x17" data-mpi={index}>
              <div className="inline-flex items-center justify-center w-16 h-16 bg-accent/10 rounded-full mb-6" data-id="element-183" data-mp="3dv8lk1no6s6l">
                <stat.icon className="w-8 h-8 text-accent" data-id="element-184" data-mp="p091nt6ovcfl" />
              </div>
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-185" data-mp="p2d2u3d7dxc6">{stat.title}</h3>
              <p className="text-gray-600" data-id="element-186" data-mp="k2qqrx942n4y">{stat.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}